import React, { useState } from "react";
import { IMenuGroup, IMenuItem } from "../../@types/types";
import GroupItem from "./GroupItem";
import AdditionalLinks from "./AdditionalLinks";

interface MenuGroupsProps {
  groups: IMenuGroup[];
  additionalLinks: IMenuItem[];
  isSearch?: boolean;
  quickLinks: IMenuItem[];
}

const MenuGroups: React.FC<MenuGroupsProps> = ({
  groups,
  isSearch,
  additionalLinks,
}) => {
  const [selectedId, setSelectedId] = useState("");

  const toggleMenu = (id: string) => {
    if (id) {
      if (selectedId && id === selectedId) {
        setSelectedId("");
      } else {
        setSelectedId(id);
      }
    }
  };

  return (
    <ul className='inner-group'>
      {groups.map((group) => {
        if (group.isVisible && group?.items?.length) {
          return (
            <GroupItem
              groupItem={group}
              key={group.id}
              isSearch={isSearch}
              selectedId={selectedId}
              toggleMenu={toggleMenu}
            />
          );
        }

        return null;
      })}

      {additionalLinks.length ? (
        <AdditionalLinks
          links={additionalLinks}
          selectedId={selectedId}
          toggleMenu={toggleMenu}
          isOnly={!groups.length && isSearch}
        />
      ) : null}
    </ul>
  );
};

export default MenuGroups;
